export const shouldOpenModuleSettings = ({
    enabled,
    isAdministrator,
    isSupportMode,
    memberIds,
}: {
    enabled: boolean;
    isAdministrator: boolean;
    isSupportMode: boolean;
    memberIds?: string[];
}) =>
    enabled &&
    isAdministrator &&
    !isSupportMode &&
    (memberIds?.length ?? 0) === 0;
